<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">Historique des paiements</h4>
      <b-button size="sm" variant="outline-primary" @click="refreshPayments">
        <feather-icon icon="RefreshCwIcon" size="14"/>
      </b-button>
    </div>
    <b-alert v-if="payments && payments.length === 0" show variant="info">
      Aucun historique de paiement pour ce client.
    </b-alert>

    <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
      <b-table
          ref="paymentsList"
          :per-page="perPage"
          :current-page="currentPage"
          :items="fetchClientSpecificProperty"
          :fields="tableFields"
          :sort-by.sync="sortBy"
          :busy="loading"
          :show-empty="true"
          empty-text="Aucune entrée enregistrée"
          responsive
          hover
          striped
      >
        <!-- Column: Code -->
        <template #cell(project_code)="data">
          <b-media vertical-align="center">
            <b-link
                v-if="$can('read_project', 'Projets')"
                :to="{ name: 'projects-view', params: { id: data.item.uid } }"
                class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.project_code
              }}
            </b-link>
            <small class="text-muted text-truncate">{{ amountToCurrency(data.item.total_pretax) }}</small>
          </b-media>
        </template>
      </b-table>

      <b-pagination
          v-if="payments && payments.length > 0"
          v-model="currentPage"
          :total-rows="meta.total"
          :per-page="perPage"
          align="center"
          class="mt-2"
      />

<!--      <div v-if="payments && payments.length > 0" class="d-flex justify-content-between mt-2">-->
<!--        <div class="font-weight-bold">-->
<!--          Total : {{ amountToCurrency(totalAmount) }}-->
<!--        </div>-->
<!--      </div>-->
    </b-overlay>
  </div>
</template>

<script>
import { formatDate } from '@core/utils/filter'
import {BAlert, BButton, BLink, BMedia, BOverlay, BPagination, BTable} from "bootstrap-vue";
import {amountToCurrency} from "@/utils/formatAmount";
import {mapState} from "vuex";
import store from "@/store";

export default {
  name: 'ClientsViewClientPaymentHistory',
  components: {BMedia, BLink, BPagination, BButton, BTable, BOverlay, BAlert },
  data() {
    return {
      tableFields: [
        { key: 'project_code', label: 'Projet concerné'},
        { key: 'last_payment', label: 'Dernier Paiement', sortable: true, formatter: val => formatDate(val, 'DD/MM/YYYY') },
        { key: 'total_paid_amount', label: 'Total encaissé', sortable: true, formatter: val => amountToCurrency(val) },
        { key: 'total_unpaid_amount', label: 'Total restant', sortable: true, formatter: val => amountToCurrency(val) },
      ],
      currentPage: 1,
      perPage: 5,
      sortBy: 'created_at',
      sortDesc: true,
      loading: false,
    }
  },
  computed: {
    clientId() {
      return this.$route.params.id
    },
    ...mapState('client', {
      payments: state => state.clientPayments,
      meta: state => state.clientPaymentsMeta,
    }),
    totalAmount() {
      return this.payments.reduce((total, payment) => total + (payment.total_paid_amount || 0), 0)
    }
  },
  methods: {
    formatDate,
    amountToCurrency,
    refreshPayments() {
      this.$refs.paymentsList.refresh();
    },
    fetchClientSpecificProperty(ctx, callback) {
      this.loading = true
      const params = {
        page: ctx.currentPage,
        perPage: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      try {
        store.dispatch('client/fetchClientPayments', {
          client: this.clientId,
          params
        }).then((response) => {
          callback(response)
        })
      } catch (error) {
        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Erreur',
            variant: 'danger',
            content: "Erreur lors du chargement des paiements"
          }
        })
      } finally {
        this.loading = false
      }
    },
  }
}
</script>